import { valueof } from '@/@types/Common';
import { OccupationCd, PaymentUnitDivisionCd, ProjectMemberRelationshipCd, RoleCd, GenderCd, ATTRIBUTE_STYLE, ATTRIBUTE_DISPLAY_STYLE } from '@/@types/constant';
import Vue from 'vue';

Vue.filter('transformRoleCd', (roleCd: valueof<keyof typeof RoleCd>) => {
  switch (roleCd) {
    case RoleCd.administrator:
      return 'プロジェクト管理者';
    case RoleCd.general:
      return '一般';
    case RoleCd.guest:
      return 'ゲスト';
    default:
      return '-';
  }
})

Vue.filter('transformGenderCd', (genderCd: valueof<keyof typeof GenderCd>) => {
  switch (genderCd) {
    case GenderCd.female:
      return '女性';
    case GenderCd.male:
      return '男性';
    case GenderCd.other:
      return 'その他';
    case GenderCd.none:
      return '未回答';
    default:
      return '-';
  }
})

Vue.filter('transformProjectMemberRelationshipCd', (projectMemberRelationshipCd: valueof<keyof typeof ProjectMemberRelationshipCd>) => {
  switch (projectMemberRelationshipCd) {
    case ProjectMemberRelationshipCd.freelance:
      return 'フリーランス';
    case ProjectMemberRelationshipCd.intern:
      return 'インターン';
    case ProjectMemberRelationshipCd.parttime:
      return 'パートタイム';
    case ProjectMemberRelationshipCd.permatemp:
      return '契約社員';
    case ProjectMemberRelationshipCd.proper:
      return 'プロパー';
    case ProjectMemberRelationshipCd.ses:
      return 'SES';
    default:
      return 'その他';
  }
})

Vue.filter('transformPaymentUnitDivisionCd', (paymentUnitDivisionCd: valueof<keyof typeof PaymentUnitDivisionCd>) => {
  switch (paymentUnitDivisionCd) {
    case PaymentUnitDivisionCd.day:
      return '円/日';
    case PaymentUnitDivisionCd.hour:
      return '円/時';
    case PaymentUnitDivisionCd.month:
      return '万円/月';
    case PaymentUnitDivisionCd.performance:
      return '実績給';
    case PaymentUnitDivisionCd.week:
      return '万円/週';
    case PaymentUnitDivisionCd.year:
      return '万円/年';
    default:
      return ''
  }
})

Vue.filter('transformOccupationCd', (occupationCd: valueof<keyof typeof OccupationCd>) => {
  switch (occupationCd) {
    case OccupationCd.designer:
      return 'デザイナー';
    case OccupationCd.markup:
      return 'マークアップエンジニア';
    case OccupationCd.programmer:
      return 'プログラマ';
    case OccupationCd.frontend :
      return 'フロントエンドエンジニア';
    case OccupationCd.backend:
      return 'バックエンドエンジニア';
    case OccupationCd.system:
      return 'システムエンジニア';
    case OccupationCd.software:
      return 'ソフトウェアエンジニア';
    case OccupationCd.mobile:
      return 'モバイルエンジニア';
    case OccupationCd.infra:
      return 'インフラエンジニア';
    case OccupationCd.network:
      return 'ネットワークエンジニア';
    case OccupationCd.database:
      return 'データベースエンジニア';
    case OccupationCd.security:
      return 'セキュリティエンジニア';
    case OccupationCd.iot:
      return 'IoTエンジニア';
    case OccupationCd.control:
      return 'コントロールエンジニア';
    case OccupationCd.builtin:
      return '組み込みエンジニア';
    case OccupationCd.pm:
      return 'PM';
    case OccupationCd.pmo:
      return 'PMO';
    case OccupationCd.pl:
      return 'PL';
    case OccupationCd.tester:
      return 'テスター';
    case OccupationCd.debugger:
      return 'デバッガ―';
    case OccupationCd.supporter:
      return 'テクニカルサポート/ヘルプデスク';
    case OccupationCd.sales:
      return '営業';
    case OccupationCd.marketer:
      return 'マーケター';
    case OccupationCd.consultant:
      return 'コンサルタント';
    case OccupationCd.researcher:
      return '研究者';
    case OccupationCd.quality:
      return 'QAエンジニア';
    case OccupationCd.web:
      return 'Webエンジニア';
    case OccupationCd.embedded:
      return 'エンベデッドエンジニア';
    case OccupationCd.customer:
      return 'カスタマーエンジニア';
    case OccupationCd.support:
      return 'サポートエンジニア';
    case OccupationCd.webdesigner:
      return 'Webデザイナー';
    case OccupationCd.consultant:
      return 'ITコンサルタント';
    case OccupationCd.bridge:
      return 'ブリッジシステムエンジニア';
    case OccupationCd.webmarketer:
      return 'Webマーケター';
    case OccupationCd.data:
      return 'データアナリスト';
    case OccupationCd.operation:
      return 'オペレーションエンジニア';
    case OccupationCd.sre:
      return 'SRE（Site Reliability Engineer）';
    case OccupationCd.server:
      return 'サーバーサイドエンジニア';
    default:
      return 'その他';
  }
})

Vue.filter('transformAttributeStyleCd', (attributeStyleCd: valueof<keyof typeof ATTRIBUTE_STYLE>) => {
  switch (attributeStyleCd) {
    case ATTRIBUTE_STYLE.DATE:
      return '日付';
    case ATTRIBUTE_STYLE.NUMBER:
      return '数値';
    case ATTRIBUTE_STYLE.OPTION:
      return '選択肢';
    case ATTRIBUTE_STYLE.PERSON:
      return '人物'
    case ATTRIBUTE_STYLE.TEXT:
      return 'テキスト'
    default:
      return '-';
  }
})

Vue.filter('transformAttributeDisplayStyleCd', (attributeDisplayStyleCd: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE>) => {
  switch (attributeDisplayStyleCd) {
    case ATTRIBUTE_DISPLAY_STYLE.ACCENT:
      return 'アクセント';
    case ATTRIBUTE_DISPLAY_STYLE.BELT:
      return '帯';
    case ATTRIBUTE_DISPLAY_STYLE.COMBO:
      return 'コンボボックス';
    case ATTRIBUTE_DISPLAY_STYLE.RADIO:
      return 'ラジオボタン'
    case ATTRIBUTE_DISPLAY_STYLE.TILE:
      return 'タイル'
    default:
      return '-';
  }
})
